import {useTranslation} from "react-i18next";
import {getAllUsers} from "../../users/UsersApi";
import React, {useEffect, useState} from "react";
import {usersTableColumnsMRT} from "../../users/UsersTableColumns";
import {useApplicationFormatter} from "../ApplicationProvider";
import {useAccount} from "../../users/AccountProvider";
import Grid from "@mui/material/Grid/Grid";
import {FormButtonBar} from "../../../shared/components/forms/FormButtonBar";
import {PrimaryButton} from "../../../shared/components/buttons/PrimaryButton";
import {CancelButton} from "../../../shared/components/buttons/CancelButton";
import {Application} from "../Application";
import {ApplicationUserGroupMembership} from "./ApplicationUserGroup";
import {EntityRef} from "../../../shared/technical/rest/entities";
import MaterialReactTable from 'material-react-table';
import {useAxios} from "../../../shared/technical/rest/AxiosProvider";
import {emptyPage, PagedResult} from "../../../shared/technical/rest/pageable";
import {User} from "../../users/User";
import {PaginationState, RowSelectionState} from "@tanstack/table-core";
import {getMaterialTableTranslation} from "../../../shared/technical/i18n/i18n";

export function AddApplicationUserGroupMembershipForm(props: {
  application: Application,
  members: ApplicationUserGroupMembership[],
  handleSave: (users: EntityRef[]) => void,
  handleClose: () => void
}) {
  const { t } = useTranslation();
  const axios = useAxios();
  const applicationFormatter = useApplicationFormatter();
  const account = useAccount();
  const [pagedResult, setPagedResult] = useState<PagedResult<User>>(emptyPage());
  const [pagination, setPagination] = useState<PaginationState>({ pageIndex: 0, pageSize: 10 });
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});
  const [globalFilter, setGlobalFilter] = useState<string>("");

  useEffect(() => {
    console.info("RowSelection: " +  JSON.stringify(rowSelection));
  }, [rowSelection]);

  function mapRowSelectionToEntityRefs(rowSelection: RowSelectionState): EntityRef[] {
    const selectedUserIds = Object.keys(rowSelection);
    return selectedUserIds.map(userId => ({ id: userId }) as EntityRef);
  }

  useEffect(() => {
    const params = "applicationNames=" + props.application.name + ((globalFilter && globalFilter.length > 0) ? "&search=" + globalFilter : "");
    getAllUsers(axios, { size: pagination.pageSize, page: pagination.pageIndex }, params).then(setPagedResult);
  }, [axios, pagination.pageIndex, pagination.pageSize, globalFilter, props.application.name]);

  return (
    <>
      <FormButtonBar sx={{}}>
        <Grid item>
          <CancelButton onClick={props.handleClose} />
        </Grid>
        <Grid item>
          <PrimaryButton onClick={() => props.handleSave(mapRowSelectionToEntityRefs(rowSelection))}
                         disableElevation={true}
                         title={t('buttons.save')} />
        </Grid>
      </FormButtonBar>
      <MaterialReactTable
        columns={usersTableColumnsMRT(t, applicationFormatter, account)}
        enableFilters={false}
        enableColumnActions={false}
        enableColumnOrdering={false}
        enableSorting={false}
        manualPagination={true}
        data={pagedResult.content}
        rowCount={pagedResult.page.totalElements}
        onPaginationChange={setPagination}
        muiTablePaginationProps={{
          rowsPerPageOptions: [5, 10, 25, 100],
          showFirstButton: true,
          showLastButton: true,
        }}
        enableRowSelection={true}
        enableMultiRowSelection={true}
        onRowSelectionChange={setRowSelection}
        getRowId={(user) => user.id || "unknown"}
        state={{ pagination, rowSelection }}
        onGlobalFilterChange={setGlobalFilter}
        initialState={{
          columnVisibility: { "id": false, "enabled": false, "emailVerified": false, "applicationRoles": false },
          density: "comfortable"
        }}
        localization={getMaterialTableTranslation()}
      />
    </>
  )
}
